export default defineNuxtRouteMiddleware(async () => {
  const authStore = useAuthStore();

  await authStore.waitForAuth();

  if (!authStore.isAuthenticated) {
    return navigateTo('/');
  }
});
